import { Pipe, PipeTransform } from '@angular/core';
 
import { CurrentUserService } from '@hub/services/CurrentUserService';
import { DateFunctions } from '@hub/common/DateFunctions';
import { eColumnType } from '@hub/generated/enums';
 
@Pipe({ name: 'dateToUserTimeZone' })
export class DateToUserTimeZonePipe implements PipeTransform {
    constructor(
        private userService: CurrentUserService,
        // private dateService: DateService
    ) {
    }
 
    public transform(dateString: string, type: eColumnType, formatString?: string): string {
        // let dateFormat = this.dateService.getDateFullFormat(this.authService.GetFormatName);
        return DateFunctions.dateToUserTimeZone(dateString, type, this.userService.GetTimeZone, formatString);
    }
}